import { render } from "./MyTravelPasses.vue?vue&type=template&id=078b904e&scoped=true&lang=pug"
import script from "./MyTravelPasses.vue?vue&type=script&lang=ts"
export * from "./MyTravelPasses.vue?vue&type=script&lang=ts"

import "./MyTravelPasses.vue?vue&type=style&index=0&id=078b904e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-078b904e"

export default script